<template>
  <div class="bg-white relative mt-20">
    <Futurefit />
    <Companies />
    <Numbercards />
    <SwiperCard />
    <Wehelp />
    <Tranformative />
    <Corporatehub />
    <Support />
    <Ourpartners />
    <Testimonial1 />
    <Contactusfinal />
    <Footer />
  </div>
</template>
<script>
import SwiperCard from "./components/SwiperCard.vue";
import Futurefit from "./components/Futurefit.vue";
import Companies from "./components/Companies.vue";
import Numbercards from "./components/Numbercards.vue";
import Wehelp from "./components/Wehelp.vue";
import Tranformative from "./components/Tranformative.vue";
import Corporatehub from "./components/Corporatehub.vue";
import Support from "./components/Support.vue";
import Ourpartners from "./components/Ourpartners.vue";
import Testimonial1 from "./components/Testimonial1.vue";
import Contactusfinal from "./components/Contactusfinal.vue";
import Footer from '../Footer.vue';
export default {
  components: {
    Futurefit,
    Companies,
    SwiperCard,
    Numbercards,
    Wehelp,
    Tranformative,
    Corporatehub,
    Support,
    Ourpartners,
    Testimonial1,
    Contactusfinal,
    Footer,
  },
  async mounted() {
    // await this.$store.dispatch("ffc/get_banner");
    await this.$store.dispatch("ffc/get_partner");
    await this.$store.dispatch("ffc/getall_testimonial");
  },
};
</script>
